const MIME_EXTENSIONS = {
  "image/jpeg": "jpg",
  "image/jpg": "jpg",
  "image/png": "png",
  "image/webp": "webp",
  "image/heic": "heic",
  "application/pdf": "pdf",
};

export const AREA_CODES = {
  Wareneingang: "WE",
  Warenausgang: "WA",
  Mehraufwand: "MA",
  Retoure: "RE",
  "Postrückläufer": "PR",
  Postruecklaeufer: "PR",
  BioWareneingang: "BWE",
  "BIO Wareneingang": "BWE",
  Kunde: "KD",
};

export function getAttachmentExtension(dataUrl, fallback = "bin") {
  const match = String(dataUrl || "").match(/^data:([^;,]+)[;,]/i);
  return MIME_EXTENSIONS[match?.[1]?.toLowerCase()] || fallback;
}

export function getAreaCode(area) {
  return AREA_CODES[area] || String(area || "ANLAGE")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^A-Z0-9]/gi, "")
    .toUpperCase()
    .slice(0, 4) || "ANL";
}

export function createAttachmentName({
  area,
  processNumber,
  attachmentType,
  sequence,
  dataUrl,
  extension,
}) {
  // processNumber=0 is kept only as a display fallback for pre-migration API data.
  const safeProcessNumber = Math.max(0, Number(processNumber) || 0);
  const safeSequence = Math.max(1, Number(sequence) || 1);
  const safeType = String(attachmentType || "ANLAGE")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^A-Z0-9]/gi, "")
    .toUpperCase() || "ANLAGE";
  const safeExtension = String(
    extension || getAttachmentExtension(dataUrl, "bin")
  ).replace(/[^a-z0-9]/gi, "").toLowerCase() || "bin";

  return `${getAreaCode(area)}-${String(safeProcessNumber).padStart(
    6,
    "0"
  )}-${safeType}-${String(safeSequence).padStart(2, "0")}.${safeExtension}`;
}

export function getRecordArea(record, fallback = "Wareneingang") {
  return record?.type || fallback;
}

export function getContractAttachmentType(label) {
  const normalized = String(label || "").toLowerCase();
  if (normalized.includes("vertrag")) return "VERTRAG";
  if (normalized.includes("sepa")) return "SEPA";
  if (normalized.includes("anlage")) return "ANLAGE";
  return "WEITERE";
}
